import {
  kindOfApplicand,
  subjectSpecForApplicand,
} from "@atgof-common/applicand";
import { DocumentSnapshot } from "@atgof-firebase/types";
import { useNavigation } from "@react-navigation/native";
import { View, ViewStyle } from "react-native";
import { Avatar, Chip, Text } from "react-native-paper";
import { referencePathForApplicand } from "../data/backend/downloader";
import { useSnapshot } from "../data/useSnapshot";
import { imagesQuery } from "@atgof-common/sheet";
import { useImage } from "../data/image";
import { initials } from "@atgof-common/util";

export function ApplicandChip({
  applicand,
  concise,
  style,
}: {
  applicand: DocumentSnapshot;
  concise?: boolean;
  style?: ViewStyle;
}) {
  const applicandKind = kindOfApplicand(applicand.ref);
  concise = concise || applicandKind === "prop";
  const desc: string | undefined = concise
    ? undefined
    : applicand.get("description");
  const { navigate } = useNavigation();
  const subjectSpec = subjectSpecForApplicand(applicand.ref);
  const navParams = subjectSpec
    ? {
        ...subjectSpec,
        path: applicand.ref.path,
      }
    : undefined;
  const onPress = () => {
    if (navParams) navigate("applicand", navParams);
  };
  const images = useSnapshot<DocumentSnapshot[] | undefined>(
    (onNext) =>
      imagesQuery(applicand.ref.collection("images"))
        .limitToLast(1)
        .onSnapshot((snapshot) => onNext(snapshot.docs)),
    [applicand.ref.path],
  );
  const referencePath = referencePathForApplicand(applicand.ref);
  const { image, registerCompletion, registerFailure } = useImage(
    images?.length ? images[0] : undefined,
    referencePath,
    true,
  );
  const imageSource = image?.source ?? image?.thumbnailSource;
  return (
    <View style={{ alignItems: "center", ...style }}>
      <View style={{ flexDirection: "row" }}>
        <Chip
          mode={applicandKind === "prop" ? "outlined" : "flat"}
          avatar={
            imageSource ? (
              <Avatar.Image
                size={24}
                source={imageSource}
                onLoad={() => registerCompletion()}
                onError={() => registerFailure(null)}
              />
            ) : (
              <Avatar.Text
                size={24}
                label={initials(applicand.get("displayName")) ?? "?"}
              />
            )
          }
          onPress={onPress}
        >
          {applicand.get("displayName")}
        </Chip>
      </View>
      {desc ? <Text variant="bodyMedium">{desc}</Text> : null}
    </View>
  );
}
